<!-- 零售终端单据新增或者编辑页面 -->
<template>
  <el-container>
    <el-header v-if="showHeader" class="backbar">
      <div class="header flex items-center" @click="back">
        <i class="el-icon-arrow-left"></i>
        <span class="header-title">[Esc] {{ this.$route.meta.title || title }}</span>
      </div>
    </el-header>

    <el-main>
      <slot />
    </el-main>

    <slot name="footer" />

    <el-footer v-if="showFooter" style="background-color: #fff; border: 1px solid #e9e9eb" :height="$pxToRem(84)">
      <div class="action-buttons flex items-center" :class="actionCenter ? 'justify-center' : 'justify-end'">
        <slot name="action" />
      </div>
    </el-footer>
  </el-container>
</template>

<script>
  export default {
    name: 'PosFormEditorContainer',

    props: {
      showFooter: {
        type: Boolean,
        default: true,
      },

      showHeader: {
        type: Boolean,
        default: false,
      },

      actionCenter: {
        type: Boolean,
        default: false,
      },

      title: {
        type: String,
        default: '',
      },

      to: {
        type: [String, Object],
        default: '',
      },
    },

    methods: {
      back() {
        this.closeSelf(this.to)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .backbar {
    background-color: white;
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 24px;
    height: 48px !important;
  }
  .header {
    height: 100%;
    width: fit-content;
    cursor: pointer;
    i {
      font-size: 24px;
    }
    &-title {
      margin-left: 10px;
      font-size: $mg-body-font-size;
      font-weight: 500px;
    }
  }

  .action-buttons {
    width: 100%;
    height: 100%;
    ::v-deep(.el-button + .el-button) {
      margin-left: 24px;
    }
  }
</style>
